<template>
  <div>
    <div class="d-flex align-center">
      <v-btn
          class="btn-titulo mx-5"
          color="primary"
          @click="abrirDialog()"
      >
        GERAR COTAÇÕES
      </v-btn>
    </div>   

    <v-dialog
        v-model="dialog"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
        scrollable
        persistent
    >
      <v-card tile>
        <div
            id="titulo-dialog"
            class="df"
        >
          <v-btn icon dark @click="fecharDialog" class="me-4">
            <v-icon>mdi-close</v-icon>
          </v-btn>

          <img :src="logo" alt="webcotacao" class="h-35px">
        </div>

        <div>
          <div class="d-flex align-center justify-space-between px-4 mb-4" style="height: 80px; box-shadow: 0 3px 6px rgba(41, 41, 41, 0.15);">
            <div>
              <h3 class="font-18">Itens à Importar</h3>
              <p class="font-14">{{ dataSet.length }} produtos a serem cotados</p>
            </div>
            <div>
              <v-btn
                  v-if="selected.length === 0"
                  class="wc-btn-actions"
                  color="error"
                  text
                  :disabled="dataSet.length === 0"
                  @click="handleClear()"
              >
                Limpar lista
              </v-btn>

              <v-btn
                  v-else
                  class="wc-btn-actions"
                  color="error"
                  text
                  @click="handleExcluirSelecionados()"
              >
                Excluir selecionados
              </v-btn>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    class="mx-2 wc-btn-actions"
                    color="primary"
                    outlined
                    :disabled="dataSet.length === 0"
                    @click="handlePercentTolerancia()"
                  >
                    Limites de quantidade
                  </v-btn>
                </template>
                <span>Defina quanto o fornecedor pode reduzir ou aumentar a quantidade que você pediu, para ajustar mínimos e fardos/caixas.</span>
              </v-tooltip>


              <v-tooltip bottom :disabled="podeAdicionarProdutosCotacao">
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on" class="d-inline-block">
                    <v-btn
                        class="wc-btn-actions"
                        color="primary"
                        :disabled="dataSet.length === 0 || !podeAdicionarProdutosCotacao"
                        @click="handleNovaCotacao()"
                    >
                      Adicionar produtos à cotação
                    </v-btn>
                  </span>
                </template>
                <span>
                  Esta ação exige permissão para Adicionar produtos à cotação. Peça a um administrador para habilitar
                  <strong>Visualizar Início Cotação</strong> no seu usuário (Controle de acesso).
                </span>
              </v-tooltip>
            </div>
          </div>

          <div>
            <!-- Estado vazio -->
            <div v-if="dataSet.length === 0 && !isLoading" class="empty-state">
              <div class="empty-state-content">
                <v-icon size="80" color="grey lighten-1">mdi-cart-outline</v-icon>
                <h3 class="mt-4 grey--text text--darken-1">Não há itens no carrinho</h3>
                <p class="grey--text">
                  Selecione um carrinho do Systock inteligência de Estoque para iniciar uma nova cotação<br>
                  ou resete os itens desse carrinho
                </p>
                <v-btn
                    color="primary"
                    class="mt-4"
                    @click="resetData"
                >
                  Resetar itens do carrinho
                </v-btn>
              </div>
            </div>

            <!-- Tabela de dados -->
            <sys-data-table
                v-else
                class="wc-table-fixed-column"
                :headers="headers"
                :items="dataSet"
                item-key="sku_systock"
                v-model="selected"
                show-select
                :height="alturaTabela"
                item-height="50"
                :loading="isLoading"
            >
              <!-- headers com tooltip -->
              <template v-for="h in headers" v-slot:[`header.${h.value}.text`]="{ header }">
                <v-tooltip v-if="h.tooltip" bottom :key="`tooltip-${h.value}`">
                  <template v-slot:activator="{ on, attrs }">
                    <div v-on="on" v-bind="attrs" class="d-flex align-center cursor-help">
                      <span v-text="header.text" />
                      <v-icon small class="ml-1" color="grey darken-1">mdi-help-circle-outline</v-icon>
                    </div>
                  </template>
                  <span v-html="h.tooltip"></span>
                </v-tooltip>
                <span v-else :key="`header-${h.value}`" v-text="header.text" />
              </template>

              <template v-slot:[`item.min_aceitavel`]="{ item }">
                <InputNumber
                    v-model="item.min_aceitavel"
                    center
                    class="input-regular w-100 font-resp txt-table-prod"
                />
              </template>

              <template v-slot:[`item.qtd_pedida`]="{ item }">
                <InputNumber
                    v-model="item.qtd_pedida"
                    center
                    class="input-regular w-100 font-resp txt-table-prod"
                />
              </template>

              <template v-slot:[`item.max_aceitavel`]="{ item }">
                <InputNumber
                    v-model="item.max_aceitavel"
                    center
                    class="input-regular w-100 font-resp txt-table-prod"
                />
              </template>

              <template v-slot:[`item.qtd_pedida_na_um_master`]="{ item }">
                <InputNumber
                    v-model="item.qtd_pedida_na_um_master"
                    center
                    class="input-regular w-100 font-resp txt-table-prod"
                />
              </template>

              <template v-slot:[`item.um_master`]="{ item }">
                {{ item.um_master || '-' }}
              </template>

              <template v-slot:[`item.preco_referencia`]="{ item }">
                {{ formatBRL(item.preco_referencia) }}
              </template>

              <!-- ações -->
              <template v-slot:[`item.acoes`]="{ item }">
                <div>
                  <SysTooltip top text="Remover item">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon v-on="on" v-bind="attrs" @click.stop="handleExcluir(item)">
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </template>
                  </SysTooltip>
                </div>
              </template>

            </sys-data-table>
          </div>
        </div>
      </v-card>
    </v-dialog>

    <PorcentagemToleranciaDialog
      :visible="openPercentTolerancia.isOpen"
      :handleClose="
      () => {
        openPercentTolerancia.isOpen = false
      }
      "
      :isAllSelected="isAllSelected"
      :selectedCount="selected.length"
      @apply-tolerancia="loadTolerancia"
    />

    <NovaCotacaoDialog
      :visible="openOpenCotacao.isOpen"
      :id-cotacao="openOpenCotacao.idCotacao"
      :handleClose="
        () => {
          openOpenCotacao.isOpen = false
        }
      "
    />
  </div>
</template>

<script setup>
import { computed, defineProps } from "vue";
import logo from "@/assets/logo_header.png"
import PorcentagemToleranciaDialog from "@/components/webcotacao/components/PorcentagemToleranciaDialog.vue";
import NovaCotacaoDialog from "@/components/webcotacao/components/NovaCotacaoDialog.vue";
import InputNumber from "@/components/webcotacao/components/InputNumber.vue";
import useCotacaoDialog from "@/components/webcotacao/composables/useCotacaoDialog";
import SysTooltip from "@/components/utils/ui_v4/tooltips/SysTooltip.vue";

const props = defineProps({
  pedidoId: { type: Number },
});

const podeAdicionarProdutosCotacao = computed(() => {
  if (typeof window === "undefined") return false;
  return localStorage.getItem("visualizar_inicio_cotacao") === "S";
});

const {
  dialog,
  openOpenCotacao,
  openPercentTolerancia,
  abrirDialog,
  fecharDialog,
  loadTolerancia,
  selected,
  handleClear,
  handleExcluirSelecionados,
  handlePercentTolerancia,
  handleNovaCotacao,
  isLoading,
  headers,
  alturaTabela,
  handleExcluir,
  dataSet,
  isAllSelected,
  formatBRL,
  resetData
} = useCotacaoDialog(props);
</script>

<style scoped>
  .empty-state {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 500px;
    padding: 2rem;
  }

  .empty-state-content {
    text-align: center;
    max-width: 500px;
  }
</style>
